import React,{useState, useEffect, useRef}  from 'react';
import {useHistory} from 'react-router-dom'
import {Segment,Header,Container,Button,  Form}  from 'semantic-ui-react'
import {useCheckForm ,SearchSelect} from '@wollo-lib/wollo-react'
import MyTabulator,{dateFormatter, autoNumFormatter} from '@wollo-lib/wollo-tabulator'
import {v1 as uuid} from 'uuid'
import AddKunde from './AddKunde'







const NeuesPaket=(props)=>
{
    
    const {db}=props

    const usersDB=db.users
    const paketeDB=db.pakete
    const [sisters, setSisters]=useState([])
    const history=useHistory()



    const [kunde,setKunde]=useState({Modus:'manuell'})
    const [paket,setPaket]=useState({
            Kunde:'',
            Dienst:'',
            Datum:Date.now()/1000,
            ShopId:'',
            Paketnummer:'',
            Status:'registriert',
            AbsenderK:'',
            Size:'Paket'
    })

    const [modalOpen,setModalOpen]=useState(false)

    
    
    useEffect(()=>{
        const getPakete= async()=>
        {
            const [mySisters,myKunde]= Promise.all([
                    paketeDB.where('Kunde').equals(paket.Kunde).toArray(),
                    usersDB.get(paket.Kunde)
                ])
            setSisters(mySisters)
            setKunde(myKunde)

        }
        if(paket.Kunde)
            getPakete()
        else
            setSisters([])
    },[paket.Kunde])

   
    
    const {errors,hasError,checkSubmit}=useCheckForm(paket,
        [
          {name:'Kunde',error:'Kunde muss angegeben werden',test:((val)=>(val!==''))},
          {name:'Dienst',error:'Dienst muss gewählt werden',test:((val)=>(val!==''))},
          {name:'Paketnummer',error:'Paketnummer muss angegeben werden',test:((val)=>(val!==''))},
          {name:'Size',error:'Grösse muss gewählt werden',test:((val)=>(val!==''))},
        ]
    )


    const handleChange=(e,{name,value})=>
    {
        setPaket(p=>({...p,[name]:value}))
    }

 
    function cellClick (cell) 
    {
        if(cell.getField()==='id')
        {
            history.push(`/show/paket/${cell.getValue()}`)
        }
    }

 
    function clickSize(e,{name})
    {
        if(kunde.Modus==='manuell')
        {
            paketeDB.update(paket.UID,{Size:  (paket.Dienst==='Brief' ? 'Brief' : 'Paket'), Status:'registriert', Kunde: kunde.UID})
        }
        else
        {
            paketeDB.update(paket.UID,{Size:name,Status:'registriert', Kunde: kunde.UID})
        }
    }


    const submit=()=>
    {
           
 
        if(!checkSubmit())
          return
        const myPaket={
            ...paket,
            UID:uuid(),
            ShopId:'',
            Size: kunde.Modus==='manuell' ? (paket.Dienst==='Brief' ? 'Brief' : 'Paket') : paket.Modus
        }
        db.pakete.add(myPaket).then
        (
           result=>console.log('insert Paket:',result)
        )
        .catch(
            e=>console.log("Dexi error insert Paket:",e,"paket",myPaket )
        )
        history.push('/')
    }


    const columns=[
   
        {formatter:autoNumFormatter, width:50, frozen:true}, //incrementing row number
        {formatter:(cell, formatterParams)=>('<i class="icon edit"></i>'), field:'id', width:50, hozAlign:"center"}, // edit 
        { title: 'Dienst', field: 'Dienst', width: 120,  headerFilter:"input"},
        { title: 'Datum', field: 'Datum', width: 120, formatter:dateFormatter},
        { title: 'Paketnummer', field: 'Paketnummer', width: 300,  headerFilter:"input"},
        { title: 'Absenderkennung', field:'AbsenderK', width: 400, headerFilter:"input"}
        
    ]
    return (
        <Container >
        {  
            ! modalOpen ?  <>

            <Segment>
               <Header as="h2">Neues Paket manuell erfassen</Header>
               <Form>
                      <Form.Field
                            label='Kunde' 
                            value={paket.Kunde} 
                            name='Kunde' 
                            onChange={handleChange} 
                            placeholder={'Kundennnamen suchen'}
                            control={SearchSelect}
                            Value2TitleUrl={{table: usersDB, field: 'UID', map: el=>(`${el.Vorname} ${el.Nachname} ${el.PLZ} ${el.Ort}`) }}
                            SuggestDexie={{ 
                                            table: usersDB,
                                            field:'fulltext', 
                                            map: el=> ({
                                                            key:el.UID, 
                                                            title:`${el.Vorname} ${el.Nachname} ${el.PLZ} ${el.Ort}`, 
                                                            value: el.UID, 
                                                            typ:'Kunde'})}} 
                            api='back'
                            autoSelect
                    />
                    <Button color='green' icon='plus' content='neuer Kunde' onClick={(e)=>{ setModalOpen(true)}}/>
                    <Form.Dropdown
                        label='Paketdienst'
                        value={paket.Dienst}
                        selection
                        options={
                            ['DHL','DHL-Express','Hermes','DPD','GLS','UPS','FEDEX']. map(el=>({key:el,text:el,value:el}))
                        }
                        placeholder = "Paketdienst wählen"
                        onChange={handleChange}
                        name='Dienst'
                        error={errors['Dienst']}
                    />
                    <Form.Input
                        label='Paketnummer'
                        value={paket.Paketnummer}
                        name='Paketnummer'
                        placeholder='Paketnummer eingeben'
                        error={errors['Paketnummer']}
                        onChange={handleChange}
                    />
                    <Form.Button
                        content='speichern'
                        icon='save'
                        onClick={submit}
                        color={hasError.current ? null : 'green'}
                    />
                    {
                        kunde.Modus=== 'manuell'  ? '' :
                        <Form.Dropdown
                            label='Paketgrösse'
                            value={paket.Size}
                            selection
                            options={
                                ['S','M','L','XL']. map(el=>({key:el,text:el,value:el}))
                             }
                            placeholder = "Paketgrösse wählen"
                            onChange={handleChange}
                            name='Size'
                            error={errors['Dienst']}
                        />
                    }
                    
                </Form>
            </Segment> 
            <Segment>
            { 
                !sisters.length ? '' :
                    <>
                        <Header> weitere Pakete dieses Kunden</Header>
                        <MyTabulator
                            index='id'
                            columns={columns}
                            headerFilterPlaceholder="Spalte filtern"
                            data={sisters}
                            onClick={cellClick}
                
                        />
                    </>
            }
            </Segment> 
            
        </>
        
        :
             <AddKunde
                    open={modalOpen}
                    setOpen={setModalOpen}
                    db={db}
                    baseHandleChange={handleChange}

            />
        }
        </Container>
    )

}
export default NeuesPaket
